import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/screens/brief/utils/briefTrackerCreatedToast";
import { OspToast } from "@ospweb/sdk-ui";
import { Track } from "@/src/lib/tracking";
import {
  BRIEF_OPENREPLAY_EVENTS,
  buildBriefTrackerToastActionPayload,
} from "./briefOpenReplay";

const I18n = I18nUtil.createScoped(Translations);

/**
 * Tracker 创建成功 Snackbar：文案 + View 跳转 Desk 详情。
 *
 * View **只有主动事件、没有 click label** —— 它是 `OspToast` 内部渲染的按钮，
 * 挂不上 `data-openreplay-label`（native 那边挂得上，见 `BRIEF_TRACKER_TOAST_VIEW_LABEL`）。
 * 两端靠**同一条事件**对齐，不靠同一个 label。
 */
export const showBriefTrackerCreatedToast = (
  onView: () => void,
  trackerId?: string,
  eventId?: string,
): void => {
  OspToast.success({
    content: I18n.t("New tracker created. Ed will post updates on Desk."),
    action: {
      label: I18n.t("View"),
      onClick: () => {
        Track.event(
          BRIEF_OPENREPLAY_EVENTS.trackerToastAction,
          buildBriefTrackerToastActionPayload(trackerId, eventId),
        );
        onView();
      },
    },
    key: "brief-tracker-created",
    duration: 5,
  });
};

/** Tracker 创建失败 */
export const showBriefCreateNoteFailedToast = (): void => {
  OspToast.error({
    content: I18n.t("Couldn't create note. Try again."),
    key: "brief-create-note-failed",
  });
};

/** Tracker 草稿拉取失败 */
export const showBriefDraftFailedToast = (): void => {
  OspToast.info({
    content: I18n.t("Ed is working on it..."),
    key: "brief-draft-failed",
  });
};
